import t from "./index49.js";
import u from "./index60.js";
import { DEFAULT_FORM_DATA_MAX_DEPTH as E } from "./index59.js";
const f = E;
function h(r) {
  if (r > f)
    throw new u(
      "FormData field is too deeply nested (" + r + " levels). Max depth: " + f,
      u.ERR_FORM_DATA_DEPTH_EXCEEDED
    );
}
function _(r) {
  const i = [], e = /\w+|\[(\w*)]/g;
  let s;
  for (; (s = e.exec(r)) !== null; )
    h(i.length), i.push(s[0] === "[]" ? "" : s[1] || s[0]);
  return i;
}
function m(r) {
  const i = {}, e = Object.keys(r);
  let s;
  const n = e.length;
  let c;
  for (s = 0; s < n; s++)
    c = e[s], i[c] = r[c];
  return i;
}
function O(r) {
  function i(e, s, n, c) {
    h(c);
    let o = e[c++];
    if (o === "__proto__")
      return !0;
    const l = Number.isFinite(+o), p = c >= e.length;
    return o = !o && t.isArray(n) ? n.length : o, p ? (t.hasOwnProp(n, o) ? n[o] = t.isArray(n[o]) ? n[o].concat(s) : [n[o], s] : n[o] = s, !l) : ((!t.hasOwnProp(n, o) || !t.isObject(n[o])) && (n[o] = []), i(e, s, n[o], c) && t.isArray(n[o]) && (n[o] = m(n[o])), !l);
  }
  if (t.isFormData(r) && t.isFunction(r.entries)) {
    const e = {};
    return t.forEachEntry(r, (s, n) => {
      i(_(s), n, e, 0);
    }), e;
  }
  return null;
}
export {
  O as default
};
